export const DEFAULT_MAP_CENTER = { lat: 49, lng: 12 };
export const DEFAULT_MAP_ZOOM = 5;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/constants/MapVariables.ts